import { Attributes, ModelBase, NeoModel, Rules, Validation } from '@singularsystems/neo-core';

@NeoModel
export default class Country extends ModelBase {
    static typeName = "Country";

    public countryId: number = 0;

    @Rules.StringLength(50)
    @Rules.Required()
    @Attributes.Display("Country")
    public countryName: string = "";

    @Rules.StringLength(3)
    @Rules.Required()
    public countryCode: string = "";

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew || !this.countryName) {
            return "New country";
        } else {
            return this.countryName;
        }
    }
}